// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"176":"projects","443":"about"}[chunkId] + "." + {"176":"10a2ef09","443":"edae9f81"}[chunkId] + ".js";
};